import { render, staticRenderFns } from "./ArchiveManagement.vue?vue&type=template&id=15d19256&scoped=true"
import script from "./ArchiveManagement.vue?vue&type=script&lang=js"
export * from "./ArchiveManagement.vue?vue&type=script&lang=js"
import style0 from "./ArchiveManagement.vue?vue&type=style&index=0&id=15d19256&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d19256",
  null
  
)

export default component.exports